import React from "react";
import { spinner, spinnerWrapper, spinnerTextWrapper } from "./Spinner.css";
import { Typography } from "@shared/ui.primitives";

export const DeprecatedSpinner: React.FC<{
  type?: "componentLevel" | "pageLevel";
  spinnerText?: string;
}> = ({ type = "componentLevel", spinnerText }) => {
  return (
    <div className={spinnerWrapper[type]}>
      <span className={spinner} />
      {spinnerText && (
        <div className={spinnerTextWrapper}>
          <Typography>{spinnerText}</Typography>
        </div>
      )}
    </div>
  );
};
